<template>
    <section
        class="bottom-footer tw-border-0 tw-border-t tw-border-solid tw-border-slate-200/60 py-4"
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <p class="mb-0 text-center text-muted">
                        Copyrights © {{ new Date().getFullYear() }}. All rights
                        reserved by
                        <Link href="/">{{ $page.props.app_name }}</Link
                        >.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: { Link },
};
</script>
